var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCarouselArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 60,
    viewBox: "0 0 32 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "icon-carousel-arrow-left-b",
    points: "7 .373 29.627 23 7 45.627 2.757 41.385 21.141 22.999 2.757 4.615"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "icon-carousel-arrow-left-a",
    width: "181.9%",
    height: "161.9%",
    x: "-40.9%",
    y: "-15.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.32 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 32.385 0)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#icon-carousel-arrow-left-a)",
    xlinkHref: "#icon-carousel-arrow-left-b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#icon-carousel-arrow-left-b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarouselArrowLeft);
export default __webpack_public_path__ + "static/media/icon-carousel-arrow-left.13177e18e0be601903e12163f9299bcb.svg";
export { ForwardRef as ReactComponent };